export default "__VITE_ASSET__a5cefadd__"